import type { QueryClient } from '@tanstack/react-query';
import createClient, { type Middleware } from 'openapi-fetch';
import createOpenapiQueryClient from 'openapi-react-query';
import type { paths } from './legacy-auth-gateway-types';

export type LegacyAuthGatewayPaths = paths;

export interface LegacyAuthGatewayApiClientParams {
  baseUrl?: string;
  queryClient: QueryClient;
  middlewares?: Middleware[];
}

// Singleton instance (optional, depending on usage pattern)
// We generally prefer passing the client via context.

const DEFAULT_BASE_URL =
  import.meta.env.VITE_LEGACY_AUTH_API_URL ||
  'https://ma-dev.privatbanka.sk/api';

/**
 * Creates and initializes the Legacy Auth Gateway API client.
 * This sets up the fetch client (openapi-fetch) and the React Query wrapper (openapi-react-query).
 */
export const createLegacyAuthGatewayClient = (
  params: LegacyAuthGatewayApiClientParams,
) => {
  // 1. Initialize openapi-fetch client
  const fetchClient = createClient<LegacyAuthGatewayPaths>({
    baseUrl: params.baseUrl || DEFAULT_BASE_URL,
  });

  // 2. Register middlewares
  const allMiddlewares = [...(params.middlewares || [])];

  allMiddlewares.forEach((mw) => {
    fetchClient.use(mw);
  });

  // 3. Initialize openapi-react-query client
  // Note: Retry logic is primarily handled by QueryClient configuration passed in `params.queryClient`
  // openapi-react-query provides the glue types and utilities.
  const rqClient = createOpenapiQueryClient(fetchClient);

  return {
    rqClient,
    fetchClient,
    queryClient: params.queryClient,
  };
};
